<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Edit Mailbox PIN</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <mat-form-field class="flex-full">
        <mat-label>Enter New PIN</mat-label>
        <input
          matInput
          autocomplete="off"
          type="text"
          [formControl]="form.get('mailboxEditPin.password')"
          id="mailboxEditPin.password"
          required
          />
          @if (
            form.get('mailboxEditPin.password')?.hasError('pattern') ||
            form.get('mailboxEditPin.password')?.hasError('required')
            ) {
            <mat-error
              >
              Please enter a valid PIN. The pin must be between 3-10 digits.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="flex-full">
          <mat-label>Confirm PIN</mat-label>
          <input
            matInput
            autocomplete="off"
            type="text"
            [formControl]="form.get('mailboxEditPin.passwordConfirm')"
            id="mailboxEditPin.passwordConfirm"
            required
            />
            @if (form.get('mailboxEditPin.passwordConfirm')?.hasError('required')) {
              <mat-error>
                Please re-enter the PIN. The pin must be between 3-10 digits.
              </mat-error>
            }
            @if (form.get('mailboxEditPin.passwordConfirm')?.hasError('validPassword')) {
              <mat-error>
                PINs do not match.
              </mat-error>
            }
          </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions>
          <button type="submit" title="Create" mat-raised-button>Save</button>
        </mat-dialog-actions>
      </form>
    </lcs-loading-overlay>
